/**
 * Client mirror of the backend's contact-method normal form
 * (Server.Common.PhoneNormalizer + Features/ContactDetail/Services/ContactMethodNormalizer).
 * This exists for instant inline feedback only — the SERVER is authoritative, and a 400 from
 * it is always surfaced verbatim via extractApiMessage rather than replaced with a local guess.
 */

export const PHONE_ERROR = 'Enter a 10-digit US phone number'
export const EMAIL_ERROR = 'Enter a valid email address'

const MAX_EMAIL_LENGTH = 320 // ValidationLimits.MaxEmailAddress

export function normalizePhone(raw: string | null | undefined): string | null {
  if (!raw || raw.trim() === '') return null
  let digits = raw.replace(/\D/g, '')
  if (digits.length === 11 && digits.startsWith('1')) digits = digits.slice(1)
  return digits.length === 10 ? digits : null
}

export function isValidPhone(raw: string): boolean {
  return normalizePhone(raw) !== null
}

export function normalizeEmail(raw: string | null | undefined): string | null {
  if (!raw || raw.trim() === '') return null
  return raw.trim().toLowerCase()
}

export function isValidEmail(raw: string): boolean {
  const value = raw.trim()
  if (value === '' || value.length > MAX_EMAIL_LENGTH) return false
  // Deliberately strict-but-simple: one @, no whitespace, a dot in the domain. The server's
  // MailAddress parse is the real gate; this only stops obvious typos before a round trip.
  return /^[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+$/.test(value)
}

export function formatPhone(phone: string): string {
  const digits = normalizePhone(phone)
  if (!digits) return phone
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
}

export function telHref(phone: string): string {
  const digits = normalizePhone(phone)
  return digits ? `tel:+1${digits}` : `tel:${phone}`
}
